(function () {
    'use strict';

    var testApp = angular
        .module('invesfleet')
        .controller('InformeNoPremiumController', InformeNoPremiumController);

  

        InformeNoPremiumController.$inject = [
        '$stateParams', 'genericDataService', '$rootScope', '$state',
        '$filter', '$q', '$scope', 'reportService', 'notificationService', 'reportingService', 'endPoints', 'common', 'userService'
    ];


    function InformeNoPremiumController($stateParams, genericDataService, $rootScope, $state,
        $filter, $q, $scope, reportService, notificationService, reportingService, endPoints, common, userService) {

        /* PUBLIC VARIABLES */
        var vm = this;
        var id = $stateParams.id;
        vm.cancelar = cancelar;

        (function () {
            loadData();
        })();

        function loadData() {
            if(id == 27) {
                drawGraph27();
            }
            else if(id == 28) {
                drawGraph28();
            }
        }

        function drawGraph27() {
                $('#bar_chart').remove();
                $('#graph-container').append('<canvas id="bar_chart" height="340"><canvas>');
                var ctx = $("#bar_chart");
                var bacChart = new Chart(ctx, {
                    type: 'horizontalBar',
                    data: setData(),
                    options: {
                        scales: {
                            yAxes: [{
                                stacked: true,
                                ticks: {
                                    beginAtZero: true
                                }
                            }],
                            xAxes: [{
                                stacked: true,
                                ticks: {
                                    autoSkip: false,
                                    maxRotation: 30,
                                    minRotation: 30,
                                    fontSize: 10
                                },
                                barThickness: 30
        
                            }]
                        },
                        lineAtIndex: 1200,
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: false,
        
                    }
                });
        
                $('#bar_chart2').remove();
                $('#graph-container2').append('<canvas id="bar_chart2" height="340"><canvas>');
                var ctx = $("#bar_chart2");
                var bacChart = new Chart(ctx, {
                    type: 'line',
                    data: setData2(),
                    options: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                }
                            }]
                        },
                        lineAtIndex: 1300,
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: false,
        
                    }
                });
        
        }

        function setData() {
            var data = { labels: [], datasets: [] };
            var dataset = {
                label: 'Media consumo', data: [], backgroundColor: 'rgb(249, 231, 242)', borderColor: 'rgb(190, 99, 216)', borderWith: 1
            };
    
    
    
            data.labels.push(' ARC PLATAFORMA 0072HHK');
            dataset.data.push(1500);
            data.labels.push(' ARC PLATAFORMA 0065KWL');
            dataset.data.push(2000);
            data.labels.push(' ARC PLATAFORMA 0059KLS');
            dataset.data.push(3000);
            data.labels.push(' ARC PLATAFORMA 8795POL');
            dataset.data.push(1400);
            data.labels.push(' ARC PLATAFORMA 0987RTS');
            dataset.data.push(1200);
            data.datasets.push(dataset);
            return data;
        }
    
         function setData2() {
            var data = { labels: [], datasets: [] };
             var dataset = {
                 label: 'Media consumo', data: [], backgroundColor: 'rgb(249, 231, 242)', borderColor: 'rgb(190, 99, 216)', borderWith: 1, fill: false
             };
    
    
    
                data.labels.push('01-07-2019');
             dataset.data.push(1400);
                
                data.labels.push('02-07-2019');
             dataset.data.push(1000);
                
                data.labels.push('03-07-2019');
             dataset.data.push(1300);
                
                data.labels.push('04-07-2019');
             dataset.data.push(1480);
                
                data.labels.push('05-07-2019');
             dataset.data.push(1265);
                
                data.labels.push('06-07-2019');
             dataset.data.push(1365);
                
                data.labels.push('07-07-2019');
             dataset.data.push(1500);
                
                data.labels.push('08-07-2019');
             dataset.data.push(1200);
                        data.datasets.push(dataset);
            return data;
        }

        function drawGraph28() { 
        
                $('#bar_chart').remove();
                $('#graph-container').append('<canvas id="bar_chart" height="340"><canvas>');
                var ctx = $("#bar_chart");
                var bacChart = new Chart(ctx, {
                    type: 'horizontalBar',
                    data: setData(),
                    options: {
                        scales: {
                            yAxes: [{
                                stacked: true,
                                ticks: {
                                    beginAtZero: true
                                }
                            }],
                            xAxes: [{
                                stacked: true,
                                ticks: {
                                    autoSkip: false,
                                    maxRotation: 30,
                                    minRotation: 30,
                                    fontSize: 10
                                },
                                barThickness: 30
        
                            }]
                        },
                        responsive: true,
                        maintainAspectRatio: false,
                        legend: false,
        
                    }
                });
        
        }

        function cancelar() {
            $state.go("flota.informes.listado");
        }



    }
})();
